<div class="row mt-2">
  <div class="d-flex">
    <p>
      <img
        alt="User Avatar"
        class="rounded-circle"
        [src]="review?.reviewedByLogo | imagePath"
      />
      &nbsp;
      <b>{{ review?.reviewedByUsername }}</b>
      &nbsp;
      <ngb-rating [max]="5" [rate]="review?.reviewRating" [readonly]="true">
      </ngb-rating>
      &nbsp;
      {{ review?.reviewText }}
    </p>
  </div>
</div>
